import type { Ev1Player } from 'types/e-v1-player-api-types';
import type { WistiaPlayer } from '@wistia/wistia-player';
import { trackStructEvent } from '~/utilities/snowplow';

interface CaptionsChangeEvent {
  visible: boolean;
  language: string;
}

export const trackLanguageChangesWithSnowplowLegacy = (
  player: Ev1Player,
  property?: string,
): void => {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  if (player.trackCaptionsChange == null) {
    // eslint-disable-next-line no-param-reassign
    player.trackCaptionsChange = ({ visible, language }: CaptionsChangeEvent) => {
      trackStructEvent({
        category: 'player_captions',
        action: visible ? 'show' : 'hide',
        label: 'player_captionschange_event',
        value: language,
        property,
      });
    };
  }
  player.unbind('captionschange', player.trackCaptionsChange);
  player.bind('captionschange', player.trackCaptionsChange);
};

export const trackLanguageChangesWithSnowplow = (player: WistiaPlayer, property?: string): void => {
  const callback = (event: CustomEvent) => {
    const { visible, language } = event.detail as CaptionsChangeEvent;
    trackStructEvent({
      category: 'player_captions',
      action: visible ? 'show' : 'hide',
      label: 'player_captionschange_event',
      value: language,
      property,
    });
  };

  player.removeEventListener('captions-change', callback);
  player.addEventListener('captions-change', callback);
};
